export const graphThemes = {
  cyberpunk: {
    backgroundColor: "#0f0f1a",
    gridColor: "rgba(148, 163, 184, 0.34)",
    minorGridColor: "rgba(148, 163, 184, 0.16)",
    axisColor: "#00ccff",
    lineColor: "#ff00ff",
    pointColor: "#00ff00",
  },
  classic: {
    backgroundColor: "#ffffff",
    gridColor: "rgba(51, 65, 85, 0.28)",
    minorGridColor: "rgba(51, 65, 85, 0.12)",
    axisColor: "#003366",
    lineColor: "#003366",
    pointColor: "#cc0000",
  },
};
